// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueResource from 'vue-resource'
import vSelect from 'vue-select'
// google analytics Plugin
import VueAnalytics from 'vue-analytics'
import App from './components/app-component/app-component'
import router from './router'

import Config from './assets/config/config'
import LangFile from './assets/config/string'
import MeasUnitFile from './assets/config/meas_units'

import store from './store.js'


Vue.use(VueResource)
// google analytics
Vue.use(VueAnalytics, {
  id: 'UA-102816052-5',
  checkDuplicatedScript: true
})

Vue.component('v-select', vSelect)

// console tips
Vue.config.productionTip = false

// vue resource config
switch (location.hostname) {
  case 'preprod-guard-installation.grohe.com':
    Vue.http.options.root = Config.host_idp_preprod
    break
  case 'www.guard-installation.grohe.com':
  case 'guard-installation.grohe.com':
    Vue.http.options.root = Config.host_idp_prod
    break
  default:
    Vue.http.options.root = Config.host_idp_dev
    break
}

// global variables
Vue.prototype.$configFile = Config
store.commit('setLangFile', LangFile)
store.commit('setMeasUnitFile', MeasUnitFile)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  store,
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js